/* import __COLOCATED_TEMPLATE__ from './diy-credits-analytics.hbs'; */
import DiyBaseAnalytics from './diy-base-analytics';
import ICON_PATH from 'sh-www/constants/assets/icons';

export default DiyBaseAnalytics.extend({
  title: 'Unlock company credits',
  text: 'View your company credit balances by upgrading to a subscription plan.',
  icon: ICON_PATH.INVOICE_REPORT,

  // the analytics table widget needs these objects
  filters: [],

  tableColumns: [{
    label: '',
    param: '',
    sortDescending: true,
    defaultSort: true,
  }],

  defaultSortIdx: null,

  init() {
    this._super(...arguments);

    this.set('data', {});
  },
});
